import { useCallback, useEffect, useState, } from "react";
import { useTranslation } from "react-i18next";
import { Box, Grid, MenuItem } from "@mui/material";

/** COMPONENT */
import TableCustom from "../../../component/table/tableCustom";
import InputTextField from "../../../component/input/inputTextField";
import FilterSelect from "../../../component/select/filterSelect";
import HeaderCard from "../../../component/cardCustom/headerCard";
import TableRowCommon from "../../../component/table/TableRowCommon";
import ButtonCustom from '../../../component/button/buttonCustom';
import ModalCustom from "../../../component/modalCustom/modalCustom";

/** STYLE */
import * as Style from "./stall.style"

/** API */
import { swalActive } from "../../../component/notification/swal";
import { useDispatch } from "react-redux";
import { resetModal, showModal, submitModal, unSubmitModal } from "../../../app/slice/modal.slice";
import { notiError, notiSuccess } from "../../../component/notification/notifications";
import { dateTimeToView } from "../../../utils/date.utils";
import { icons } from "../../../constants/images";
import { isCreate, isDelete, isUpdate, isView } from "../../../utils/permission.utils";
import { Col, Row } from "react-bootstrap";
import RepairTypeApi from "../../../api/setting/repair/repairType.api";


const initStateErrorMessage = {
  MAINTENANCE_NAME_TH: ``,
  IS_DUPLICATE_MAINTENANCE_NAME_TH: ``,
  MAINTENANCE_NAME_TH_STRING_BASE: ``,
  MAINTENANCE_NAME_TH_STRING_EMPTY: ``,
  MAINTENANCE_NAME_TH_MAXIMUM_LENGTH: ``,
  MAINTENANCE_NAME_TH_ANY_REQUIRED: ``,

  MAINTENANCE_NAME_EN: ``,
  IS_DUPLICATE_MAINTENANCE_NAME_EN: ``,
  MAINTENANCE_NAME_EN_STRING_BASE: ``,
  MAINTENANCE_NAME_EN_STRING_EMPTY: ``,
  MAINTENANCE_NAME_EN_MAXIMUM_LENGTH: ``,
  MAINTENANCE_NAME_EN_ANY_REQUIRED: ``
}

const permissions = {
  isCreate: isCreate(),
  isDelete: isDelete(),
  isUpdate: isUpdate(),
  isView: isView()
}

export default function MaintenanceType() {

  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [errorMessage, setErrorMessage] = useState<any>(initStateErrorMessage)
  const [repairTypeId, setRepairTypeId] = useState(Number)
  const [repairTypeName, setrepairTypeName] = useState<string>('')
  const [repairTypeNameEn, setRepairTypeNameEn] = useState<string>('')
  const [repairTypeStatus, setRepairTypeStatus] = useState<string>('ACTIVE')
  const [maintenanceTypeData, setMaintenanceTypeData] = useState<any[]>([])
  const [page, setPage] = useState<number>(1)
  const [pageLimit, setPageLimit] = useState<number>(5)
  const [rowCount, setRowCount] = useState<number>()
  const [sortBy, setSortBy] = useState<string>('modifiedDate')
  const [sortType, setSortType] = useState<string>('ASC')
  const [search, setSearch] = useState<string>('')
  const [status, setStatus] = useState<string>('ALL')

  const loadData = useCallback(async () => {

    let condition: any = {}
    if (page) condition = { ...condition, page: page }
    if (pageLimit) condition = { ...condition, pageLimit: pageLimit }
    if (search) condition = { ...condition, search: search }
    if (sortBy) condition = { ...condition, sortBy: sortBy }
    if (sortType) condition = { ...condition, sortType: sortType }
    if (status) condition = { ...condition, status: status === 'ALL' ? '' : status }

    const res = await RepairTypeApi.findAll(condition)

    if (res.status === 200) {
      setRowCount(res.headers['total'])
      setMaintenanceTypeData(res.data)

    } else {
      setRowCount(0)
      setMaintenanceTypeData([])
    }

  }, [page, pageLimit, search, sortBy, sortType, status])


  useEffect(() => {
    loadData()
  }, [loadData])

  const handlePageChange = (newPage: number) => {
    setPage(newPage);
  };

  const handlePageLimitChange = (newPageLimit: number) => {
    setPageLimit(newPageLimit);
  };

  const handleChangeStatus = (newStatus: string) => {
    setStatus(newStatus)

  }

  const onRequestSort = (sortBy: string, sortType: string) => {
    setSortType(sortType)
    setSortBy(sortBy)
  }

  const headCells = [
    { id: "repairTypeId", disablePadding: false, label: "NO" },
    { id: "repairTypeName", disablePadding: false, label: t("MAINTENANCE.HEADCELL.MAINTENANCETYPENAMETH"), sortable: true },
    { id: "maintenanceTypeNameEn", disablePadding: false, label: t("MAINTENANCE.HEADCELL.MAINTENANCETYPENAMEEN"), sortable: true },
    { id: "status", disablePadding: false, align: 'center', label: t("MAINTENANCE.HEADCELL.STATUS"), sortable: true },
    { id: "modifiedId", disablePadding: false, align: 'center', label: t("MAINTENANCE.HEADCELL.MODIFIEDBY"), sortable: true },
    { id: "action", disablePadding: false, label: t("MAINTENANCE.HEADCELL.ACTION") }
  ];

  const onActive = (id: number, valueStatus: string) => {
    swalActive(
      `<p class="mb-0 mx-auto" style="max-width: 325px">${t('MAINTENANCE.ALERT.CONFIRM_STATUS')}</p>`,
      null, (res: any) => {
        if (res) {
          RepairTypeApi.updateStatus(id, valueStatus)
            .then((res) => {
              notiSuccess(t('MAINTENANCE.MESSAGE.SUCCESS.UPDATE_STATUS'), '', null, null)

              loadData()
            })
            .catch((e) => {
              notiError(t('MAINTENANCE.MESSAGE.ERROR'), '', null, null)

            })
        }
      })
  }
  const onDelete = (data: any) => {
    const { repairTypeId, repairTypeName, maintenanceTypeNameEn } = data

    swalActive(
      `<p class="mb-0 mx-auto" style="max-width: 325px">${t('MAINTENANCE.ALERT.CONFIRM_DELETE')}</p>`,
      `<p class="mb-0 mx-auto" style="max-width: 325px">${t('MAINTENANCE.ALERT.CONFIRM_DELETE', {
        maintenanceTypeNameTh: repairTypeName, maintenanceTypeNameEn: maintenanceTypeNameEn ? ' ' + maintenanceTypeNameEn + '' : ''
      })}</p>`,
      (res: any) => {
        if (res) {
          RepairTypeApi.delete(repairTypeId)
            .then((res) => {
              notiSuccess(t('MAINTENANCE.MESSAGE.SUCCESS.DELETE'), '', null, null)
              loadData()
            })
            .catch((e) => {
              notiError(t('MAINTENANCE.MESSAGE.ERROR'), '', null, null)
            })
        }
      }
    )
  }

  const onEdit = (data: any) => {
    const { repairTypeId, repairTypeName, repairTypeNameEn, status } = data
    setRepairTypeId(repairTypeId)
    setrepairTypeName(repairTypeName)
    setRepairTypeNameEn(repairTypeNameEn)
    setStatus(status)
    dispatch(showModal())
  }

  const resetForm = () => {
    setRepairTypeId(0)
    setrepairTypeName('')
    setRepairTypeNameEn('')
    setRepairTypeStatus('ACTIVE')
    clearErrorMessage()
  }

  const renderData = (objData: any, no: number) => {
    no = page * pageLimit - pageLimit + no + 1

    const { repairTypeId, repairTypeName, repairTypeNameEn, modifiedBy, modifiedDate, status } = objData;

    const statusBtnActive = status === "ACTIVE" ? true : permissions.isUpdate.disabled;
    const statusBtnInActive = status === "INACTIVE" ? true : permissions.isUpdate.disabled;
    const objRenderData = {
      key: repairTypeId,
      id: repairTypeId,
      obj: objData,
      columns: [
        { option: "TEXT", align: "left", label: no },
        { option: "TEXT", align: "left", label: repairTypeName || "-" },
        { option: "TEXT", align: "left", label: repairTypeNameEn || "-" },
        { option: "STATUS", align: "center", label: status || "-" },
        {
          option: "UPDATE_BY", align: "left", label: { updatedBy: `${(modifiedBy && (modifiedBy.firstname && modifiedBy.lastname)) ? modifiedBy.firstname + ' ' + modifiedBy.lastname : modifiedBy?.firstname || modifiedBy?.lastname || '-'}`, updatedAt: modifiedDate }
        },
        {
          option: 'ACTION',
          align: 'center',
          label: 'action',
          values: [
            { option: 'STATUS_ACTIVE', label: t(`STATUS.ACTIVE`), disabled: statusBtnActive },
            { option: 'STATUS_INACTIVE', label: t(`STATUS.INACTIVE`), disabled: statusBtnInActive },
            { option: 'DIVIDER', label: '', disabled: false },
            { option: 'EDIT', label: t(`BUTTON.EDIT`), disabled: permissions.isUpdate.disabled },
            { option: 'DELETE', label: t(`BUTTON.DELETE`), disabled: permissions.isDelete.disabled }
          ]
        }
      ],

    };
    return (
      <TableRowCommon
        {...objRenderData}
        onactive={() => onActive(Number(objRenderData.id), 'ACTIVE')}
        oninactive={() => onActive(Number(objRenderData.id), 'INACTIVE')}
        onedit={() => onEdit(objRenderData.obj)}
        ondelete={() => onDelete(objRenderData.obj)}
      />
    )
  };


  const submit = () => {
    if (!repairTypeName) return setErrorMessage({ ...errorMessage, ...{ MAINTENANCE_NAME_TH: t('MAINTENANCE.MESSAGE.MAINTENANCE_NAME_TH') } })
    if (!repairTypeNameEn) return setErrorMessage({ ...errorMessage, ...{ MAINTENANCE_NAME_EN: t('MAINTENANCE.MESSAGE.MAINTENANCE_NAME_EN') } })

    dispatch(submitModal())
    const condition: any = {
      repairTypeName: repairTypeName,
      repairTypeNameEn: repairTypeNameEn
    }
    RepairTypeApi.create(condition)
      .then((res: any) => {
        if (res.status !== undefined && res.status === 201) {
          notiSuccess(t('MAINTENANCE.MESSAGE.SUCCESS.CREATE'), '', null, null)
          resetForm()
          loadData()
          dispatch(resetModal())
        } else {
          const err = res.response.data

          setErrorMessage({
            ...errorMessage,
            ...{
              [err.error_description]: t(`MAINTENANCE.MESSAGE.${err.error_description}`)
            }
          })
          if (err.statusCode === 400) {
            if (err.error_description === t('MAINTENANCE.MESSAGE.IS_DUPLICATE_MAINTENANCE_NAME_TH')) {
              setErrorMessage({
                ...errorMessage,
                ...{
                  MAINTENANCE_NAME_TH: t(`${t(err.error_description)}`),

                }
              })
            } else if (err.error_description === t('MAINTENANCE.MESSAGE.IS_DUPLICATE_MAINTENANCE_NAME_EN')) {
              setErrorMessage({
                ...errorMessage,
                ...{
                  MAINTENANCE_NAME_EN: t(`${t(err.error_description)}`),

                }
              })
            }

          }
          dispatch(unSubmitModal())
        }
      })
      .catch((e) => {
        const err = e.response.data
        setErrorMessage({ ...errorMessage, ...{ [err.error_description]: t(`MAINTENANCE.MESSAGE.${err.error_description}`) } })
        if (err.statusCode === 400) {
          if (err.error_description === t('MAINTENANCE.MESSAGE.IS_DUPLICATE_MAINTENANCE_NAME_TH')) {
            setErrorMessage({
              ...errorMessage,
              ...{
                MAINTENANCE_NAME_TH: t(`${t(err.error_description)}`),

              }
            })
          } else if (err.error_description === t('MAINTENANCE.MESSAGE.IS_DUPLICATE_MAINTENANCE_NAME_EN')) {
            setErrorMessage({
              ...errorMessage,
              ...{
                MAINTENANCE_NAME_EN: t(`${t(err.error_description)}`),

              }
            })
          }

        }

        dispatch(unSubmitModal())
      })

  }

  const submitEdit = () => {
    if (!repairTypeName) return setErrorMessage({ ...errorMessage, ...{ MAINTENANCE_NAME_TH: t('MAINTENANCE.MESSAGE.MAINTENANCE_NAME_TH') } })
    if (!repairTypeNameEn) return setErrorMessage({ ...errorMessage, ...{ MAINTENANCE_NAME_EN: t('MAINTENANCE.MESSAGE.MAINTENANCE_NAME_EN') } })
    dispatch(submitModal())
    RepairTypeApi.update(repairTypeId, { repairTypeName, repairTypeNameEn, status: repairTypeStatus })
      .then((res: any) => {
        if (res.status !== undefined && res.status === 205) {
          notiSuccess(t(`MAINTENANCE.MESSAGE.SUCCESS.UPDATE`), '', null, null)
          resetForm()
          loadData()
          dispatch(resetModal())
        } else {
          const err = res.response.data
          setErrorMessage({ ...errorMessage, ...{ [err.error_description]: t(`MAINTENANCE.MESSAGE.${err.error_description}`) } })
          dispatch(unSubmitModal())
        }
      })
      .catch((e) => {
        const err = e.response.data
        setErrorMessage({ ...errorMessage, ...{ [err.error_description]: t(`MAINTENANCE.MESSAGE.${err.error_description}`) } })
        dispatch(unSubmitModal())
      })
  }

  const clearErrorMessage = () => {
    setErrorMessage(initStateErrorMessage)
  }

  return (
    <>
      <HeaderCard text={t("MAINTENANCE.TITLE")} />
      <Style.MainContainer>
        <Box>
          <Row>
            <Col lg={3} md={6} xs={12} className="my-1">
              <InputTextField label={t("MAINTENANCE.INPUT.SEARCH")}
                value={search}
                onchange={(event) => {
                  setSearch(event.target.value)
                  setPage(1)
                }}
              />
            </Col>
            <Col lg={3} md={6} xs={12} className="my-1">
              <FilterSelect
                onchange={(event) => {
                  const value = event.target.value
                  if (value) {
                    handleChangeStatus(value)
                    setPage(1)
                  }
                }}
                renderValue={() => `${t('STATUS.LABEL')}: ${t(`STATUS.${status}`)}`}
                label={t('STATUS.LABEL')}
                selectId="select-status"
                value={status}
                labelId="label-status"
                options={[
                  <MenuItem key="1" value="ALL">
                    {t('STATUS.ALL')}
                  </MenuItem>,
                  <MenuItem key="2" value="ACTIVE">
                    {t('STATUS.ACTIVE')}
                  </MenuItem>,
                  <MenuItem key="3" value="INACTIVE">
                    {t('STATUS.INACTIVE')}
                  </MenuItem>
                ]}
              />
            </Col>
            <Col lg={3} md={6} xs={12}></Col>
            <Col lg={3} md={6} xs={12} className="my-1">
              
                <ButtonCustom style={{ width: '100%' }}
                  disabled={permissions.isCreate.disabled}
                  type="button"
                  textButton={t('MAINTENANCE.BUTTON.ADD')}
                  endIcon={<img src={icons.add} />}
                  onClick={() => dispatch(showModal())}
                />
            </Col>
          </Row>
        </Box>
        <Style.TableContainer>

          <TableCustom
            headCells={headCells}
            customScroll
            page={page}
            pageLimit={pageLimit}
            sortType={sortType}
            sortBy={sortBy}
            rowCount={rowCount}
            rowsData={maintenanceTypeData.map((data: any, index: number) => {
              return renderData(data, index);
            })}
            onSort={onRequestSort}
            setPageLimit={handlePageLimitChange}
            setPage={handlePageChange}
            tableMinWidth={1200}
          />
        </Style.TableContainer>

      </Style.MainContainer>

      <ModalCustom
        title={repairTypeId ? t('MAINTENANCE.TITLE_UPDATE') : t('MAINTENANCE.TITLE_CREATE')}
        component={
          <div className="pb-2">
            <InputTextField
              key="repairTypeName"
              onchange={(event) => {
                setrepairTypeName(event.target.value)
                clearErrorMessage()
              }}
              value={repairTypeName}
              helperText={
                errorMessage.MAINTENANCE_NAME_TH ||
                errorMessage.IS_DUPLICATE_MAINTENANCE_NAME_TH ||
                errorMessage.MAINTENANCE_NAME_TH_STRING_BASE ||
                errorMessage.MAINTENANCE_NAME_TH_STRING_EMPTY ||
                errorMessage.MAINTENANCE_NAME_TH_MAXIMUM_LENGTH ||
                errorMessage.MAINTENANCE_NAME_TH_ANY_REQUIRED
              }
              required={true}
              style={{ marginBottom: '1rem' }}
              heading={t('MAINTENANCE.INPUT.MAINTENANCE_NAME_TH')}
            />
            <InputTextField
              key="repairTypeNameEn"
              onchange={(event) => {
                setRepairTypeNameEn(event.target.value)
                clearErrorMessage()
              }}
              value={repairTypeNameEn}
              helperText={
                errorMessage.MAINTENANCE_NAME_EN ||
                errorMessage.IS_DUPLICATE_MAINTENANCE_NAME_EN ||
                errorMessage.MAINTENANCE_NAME_EN_STRING_BASE ||
                errorMessage.MAINTENANCE_NAME_EN_STRING_EMPTY ||
                errorMessage.MAINTENANCE_NAME_EN_MAXIMUM_LENGTH ||
                errorMessage.MAINTENANCE_NAME_EN_ANY_REQUIRED
              }
              required={true}
              heading={t('MAINTENANCE.INPUT.MAINTENANCE_NAME_EN')}
            />
            <div className="mt-3">
              <FilterSelect
                heading={`${t('STATUS.LABEL')}`}
                onchange={(event) => {
                  const value = event.target.value
                  if (value) {
                    setRepairTypeStatus(value)
                  }
                }}
                renderValue={() => `${t(`STATUS.${repairTypeStatus}`)}`}
                label={t('STATUS.LABEL')}
                selectId="select-status-update"
                value={status}
                labelId="label-status-update"
                options={[
                  <MenuItem key="1" value="ACTIVE">
                    {t('STATUS.ACTIVE')}
                  </MenuItem>,
                  <MenuItem key="2" value="INACTIVE">
                    {t('STATUS.INACTIVE')}
                  </MenuItem>
                ]}
              />
            </div>
          </div>
        }
        onReset={resetForm}
        onSubmit={repairTypeId ? submitEdit : submit}
        textBtnCancel={t('MAINTENANCE.BUTTON.CANCEL')}
        textBtnConfirm={t('MAINTENANCE.BUTTON.SAVE')}
      />

    </>
  );
}
